import { render, staticRenderFns } from "./RequestPasswordResetScreen.vue?vue&type=template&id=1a286a72&scoped=true&"
import script from "./RequestPasswordResetScreen.vue?vue&type=script&lang=js&"
export * from "./RequestPasswordResetScreen.vue?vue&type=script&lang=js&"
import style0 from "./RequestPasswordResetScreen.vue?vue&type=style&index=0&id=1a286a72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a286a72",
  null
  
)

export default component.exports